import { GlobalConfig, IndividualConfig } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { Theme, ThemeKeys } from '../../interfaces/ui/ui.interface';

export const FORMAT_FOR_DATES = 'dd/MM/yyyy HH:mm';

export const FORMAT_FOR_DATES_SHORT = 'dd/MM/yyyy';

export const FORMAT_FOR_TIME = 'HH:mm';

export const FORMAT_FOR_DAY_MONTH_TIME = 'd MMM, HH:mm';

export const FORMAT_FOR_DAY_MONTH_YEAR_TIME = 'd MMM yyyy, HH:mm';

export const FORMAT_FOR_DATES_LONG = 'dd/MM/yyyy HH:mm:ss';

export const FORMAT_INPUT_DATE = 'yyyy-MM-ddTHH:mm';
export const FORMAT_INPUT_DATE_NUMERIC = 'YYYY-MM-DDTHH:mm';

export const DEFAULT_SEARCH_NG_SELECT_TERM_DELAY = 150;

export const DOWNLOAD_FILE_DELAY_MS = 1000;

export const LONG_PRESS_DURATION_MS = 500;

export const OCR_FIELD_PULSE_DURATION_MS = 5000;

export const PLAYER_CODE_LOOKUP_DEBOUNCE_MS = 400;
export const WITHDRAWAL_CODE_LOOKUP_DEBOUNCE_MS = 700;

export const WITHDRAWAL_CODE_MIN_LENGTH_FOR_LOOKUP = 6;

export const TRANSFER_CODE_MAX_LENGTH = 15;

export const BUTTON_ACTIONS = {
  ACCEPT: 'accept',
  ADD: 'add',
  CANCEL: 'cancel',
  COPY: 'copy',
  CREATE: 'create',
  CSV: 'csv',
  DELETE: 'delete',
  EDIT: 'edit',
  EXCEL: 'excel',
  FILTER: 'filter',
  RELOAD: 'reload',
  RESET: 'reset',
  RESOURCE: 'resource',
  RESTORE: 'restore',
  SAVE: 'save',
  STATS: 'stats',
  UPDATE: 'update',
  VIEW: 'view',
  REJECT: 'reject',
  PROCESS: 'process',
  STATE: 'state',
  ACTIVE: 'active',
  DEPOSIT: 'deposit',
  BULK: 'bulk',
} as const;

export const DEFAULT_GLOBAL_TOASTR_CONFIG: Partial<GlobalConfig> = {
  maxOpened: 1,
  autoDismiss: true,
  preventDuplicates: true,
};

export const DEFAULT_INDIVIDUAL_TOASTR_CONFIG: Partial<IndividualConfig<any>> = {
  positionClass: 'custom-toastr-top',
  closeButton: true,
  progressBar: true,
  timeOut: 3000,
  easeTime: 500,
  easing: 'ease-in-out',
  progressAnimation: 'decreasing',
};

export const STATUS_CONTROL = {
  ENABLE: 'enable',
  DISABLE: 'disable',
} as const;

export const NG_SELECT_QUERIES = {
  CURRENCIES: 'currencies',
  COUNTRIES: 'countries',
  BIRTH_COUNTRIES: 'birthCountries',
  BIRTH_CITIES: 'birthCities',
  PERCENTAGES: 'referalPercentages',
  TELEPHONE_CODES: 'telephoneCodes',
  COUNTRY: 'country',
  LANGUAGE: 'language',
  CITIES: 'cities',
  GENDER: 'gender',
  USERS: 'users',
  AGENTS: 'agents',
  BETSHOPS: 'betshops',
  USER_ROLES: 'userRoles',
  COMISSION_PLANS: 'comissionPlans',
  SPORTS: 'sports',
  BANKS: 'banks',
  PLAYERS: 'players',
  BONUSES: 'bonuses',
  COLLABORATORS: 'collaborators',
  CASINO_GAMES: 'casinoGames',
  PROVIDERS: 'providers',
  REGIDERED_BY: 'registeredBy',
  PERFORMED_BY: 'performedBy',
  CATEGORIES: 'categories',
  TOURNAMENTS: 'tournaments',
  EVENTS: 'events',
  ACCOUNTS: 'accounts',
  REFERALS_LINKS: 'referalsLinks',
  AUDIT_ACTIONS: 'auditActions',
  AUDIT_MODULES: 'auditModules',
  AUDIT_COLLECTIONS: 'auditCollections',
} as const;

export const DEFAULT_SEARCH_NG_SELECT_PAGINATION = {
  LIMIT: 10,
  PAGE: 1,
};

export const YEARS_DATA = [2024, 2025, 2026, 2027, 2028, 2029, 2030, 2031, 2032, 2033, 2034, 2035];

export const MONTH_DATA = [
  'jan',
  'feb',
  'mar',
  'apr',
  'may',
  'jun',
  'jul',
  'aug',
  'sep',
  'oct',
  'nov',
  'dec',
];

export const DAYS_DATA = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
];

export const FORMAT_FOR_CURRENCY_CODE = 'USD';

export const FORMAT_FOR_CURRENCY_DISPLAY = 'symbol';

export const FORMAT_FOR_CURRENCY_DIGITS = '1.2-2';

export const FORMAT_FOR_PERCENT_DIGITS = '1.2-2';

export const FORMAT_FOR_NUMBER_DIGITS = '1.2-2';

export const FORMAT_FOR_INTEGER = '1.0-0';

export const DASHBOARD_CARD_ICONS = {
  TOP_PLAYERS: 'stroke-user',
  TOP_AGENTS: 'stroke-social',
  TOP_BONUSES: 'stroke-bonus-kit',
  TOTAL_TYPES_BETS: 'betting-history',
} as const;

export const swalWithBootstrapButtons = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-secondary',
    cancelButton: 'btn btn-danger',
    actions: 'd-flex gap-2',
  },
  buttonsStyling: false,
  reverseButtons: true,
});

export const MODAL_CONFIGURATION_TYPE = {
  CODE_INYECTION: 'codeInjection',
  ABOUT_US: 'aboutUs',
  PRIVACY_POLICY: 'privacyPolicy',
  COOKIE_POLICY: 'cookiePolicy',
  TERMS_AND_CONDITIONS: 'termsAndConditions',
  RESPONSIBLE_GAMING: 'responsibleGaming',
  WHATSAPP_MESSAGE: 'whatsAppMessage',
  FAQS: 'faqs',
  TUTORIALS: 'tutorials',
  CONTACT: 'contact',
  BONUS_INFORMATION: 'bonusInformation',
  QUICK_ACCESS_MENU: 'quickAccessMenu',
} as const;

export const AVAILABLE_THEMES: Record<ThemeKeys, Theme> = {
  LIGHT_ONLY: 'light-only',
  DARK_ONLY: 'dark-only',
} as const;

export const THEME_SWITCHING_CLASS = 'theme-switching';

export const ICONS_DASHBOARD_GENERAL_STATS = {
  agentsToday: 'fill-user',
  agentsThisMonth: 'fill-user',
  agentsTotal: 'fill-user',
  playersToday: 'user-visitor',
  playersThisMonth: 'user-visitor',
  playersTotal: 'user-visitor',
  betsToday: 'doller-return',
  betsThisMonth: 'doller-return',
  todayCashDesk: 'doller-return',
  monthCashDesk: 'doller-return',
  allCashDesk: 'doller-return',
};

export const TIME_PERIODS = {
  TODAY: 'today',
  WEEK: 'week',
  MONTH: 'month',
  YEAR: 'year',
};

export const TIME_PERIODS_SELECT = [
  { value: 'today', label: 'dashboard.filters.today' },
  { value: 'week', label: 'dashboard.filters.week' },
  { value: 'month', label: 'dashboard.filters.month' },
  { value: 'year', label: 'dashboard.filters.year' },
];

export const SELECTED_FILTER_TIME_PERIODS: 'today' | 'week' | 'month' | 'year' = 'today';

export const PRODUCTS_SELECT = [
  { value: 'allProducts', label: 'dashboard.filters.allProducts' },
  { value: 'sportsBets', label: 'dashboard.filters.sportsBets' },
  { value: 'specialBets', label: 'dashboard.filters.specialBets' },
  { value: 'casino', label: 'dashboard.filters.casino' },
  { value: 'liveCasino', label: 'dashboard.filters.liveCasino' },
  { value: 'virtualGames', label: 'dashboard.filters.virtualGames' },
];

export const SELECTED_FILTER_PRODUCTS:
  | 'allProducts'
  | 'sportsBets'
  | 'specialBets'
  | 'casino'
  | 'liveCasino'
  | 'virtualGames' = 'allProducts';

export const DEFAULT_TOTAL_BETS = {
  System: 0,
  Simple: 0,
  Multiple: 0,
};

export const VERSION_APP = '2.0.0';

export enum AVAILABLE_BROWSERS {
  EDGE = 'Edge',
  CHROME = 'Chrome',
  BRAVE = 'Brave',
  OPERA = 'Opera',
  CHROMIUM = 'Chromium',
  UNKNOWN = 'Unknown',
}

export enum TECHNOLOGICAL_PLATFORM {
  MOBILE = 'Mobile',
  DESKTOP = 'Desktop',
  UNKNOWN = 'Unknown',
}

export enum BROWSERS_VERSION {
  EDGE = 'microsoft edge',
  CHROME = 'google chrome',
  BRAVE = 'brave',
  OPERA = 'opera',
  CHROMIUM = 'chromium',
}

export const PLATFORMS = [
  { value: 'windows', label: 'Windows' },
  { value: 'macos', label: 'macOS' },
  { value: 'linux', label: 'Linux' },
  { value: 'android', label: 'Android' },
  { value: 'ios', label: 'iOS' },
  { value: 'chromeos', label: 'Chrome OS' },
  { value: 'other', label: 'words.other' },
  { value: 'unknown', label: 'reports.loginHistory.unknownDevice' },
];

export const ROLE_GROUP_ICONS: Record<string, string> = {
  admin: 'fa fa-users',
  agent: 'fa fa-user-secret',
  cashdesk: 'fa fa-desktop',
  collaboratorAgent: 'icofont icofont-user-suited',
  collaboratorOperator: 'icofont icofont-ui-head-phone',
  guest: 'fa fa-user',
  default: 'fa fa-user',
};
